<template>
  <validation-observer ref="observer" v-slot="{ failed }">
    <div v-if="$store.state.debug.navigation" class="row">
      <div class="col">
        <table style="width:100%;">
          <tr>
            <th>id</th>
            <th>name</th>
            <th>viewed</th>
            <th>triggerSecId</th>
            <th>targetSecId</th>
            <th>question ids</th>
          </tr>
          <tr v-for="section in activeSurveyNavSections" :key="section.id">
            <td>{{ section.id }}</td>
            <td>{{ section.name }}</td>
            <td>{{ section.viewed }}</td>
            <td>{{ section.triggerSectionId }}</td>
            <td>{{ section.targetSectionId }}</td>
            <td>{{ section.questionIds }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="row justify-content-end" v-if="displayProgress">
      <div class="col-md-6 mb-3">
        <base-progress :value="progress" :type="colorScheme"></base-progress>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <survey-section
          v-for="section in sections"
          :sectionContent="section"
          :active="section.hspSectionId == activeSectionId"
          :key="section.hspSectionId"
          :missingResponseSection="missingResponseSection"
          :invalidate="invalidate"
          :isDarkMode="isDarkMode"
          @putSectionResponses="putSectionResponses"
          @nav="handleNav">
          <required-alert :failed="failed" :isValidated="isValidated"></required-alert>
          <custom-alert :show="showMissingResponsesAlert" :alerts="missingResponsesAlert"></custom-alert>
        </survey-section>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import { BaseProgress } from '../../components';
import SurveySection from './Section';
import RequiredAlert from './RequiredAlert';
import CustomAlert from './CustomAlert';
import { ValidationObserver } from 'vee-validate';
import { mapGetters, mapActions } from 'vuex';
import { isDarkMode } from 'src/modules/utils';

export default {
  components: {
    BaseProgress,
    SurveySection,
    ValidationObserver,
    RequiredAlert,
    CustomAlert
  },
  props: {
    missingResponseSection: Object,
    invalidate: Boolean,
    isDarkMode: {
      type: Boolean,
      default: isDarkMode(),
    },
  },
  data() {
    return {
      isValidated: false
    }
  },
  computed: {
    progress() {
      // Negative ordinals do not count in the progress bar calculations. The total number of sections that count equals
      // the number of sections minus the index of the first section with an ordinal of 1. Likewise, the current section
      // value is offset by the index of the first section with an ordinal of 1, e.g., current section index minus the 
      // index of the first section with ordinal 1.
      let firstOrdinalIndex = this.activeSurveyNavSections.findIndex(section => section.ordinal > 0);
      let total = firstOrdinalIndex >= 0 ? this.activeSurveyNavSections.length - firstOrdinalIndex : this.activeSurveyNavSections.length;
      let currentIndex = this.activeSurveyNavSections.findIndex(section => section.id === this.activeSectionId);
      let current = firstOrdinalIndex >= 0 ? (currentIndex - firstOrdinalIndex + 1) : currentIndex + 1;
      let progress = current <= 0 ? 0 : Math.round(current / total * 100);

      return progress;
    },
    displayProgress() {
      return this.progress > 0 ? true : false;
    },
    showMissingResponsesAlert() {
      return this.missingResponseSection && this.missingResponseSection.hspSectionId !== this.activeSectionId? true : false;
    },
    missingResponsesAlert() {
      if (!this.showMissingResponsesAlert) {
        return [];
      }

      return [ 
        "There is still section(s) which require responses before completing the survey.",
        "You will be navigated back to the section <b><i>" + this.missingResponseSection.sectionTitle + "</i></b> when you press the 'Next' button."
      ];
    },
    ...mapGetters({
      colorScheme: 'colorScheme',
      sections: 'activeSurveySections',
      activeSurveyNavSections: 'activeSurveyNavSections',
      activeSectionId: 'activeSectionId',
      isLastQuestionsSection: 'isLastQuestionsSection',
    })
  },
  methods: {
    handleNav(type, categoryQuestionIds) {
      let obs = this.$refs.observer;

      if(type === 'previous') {
        this.isValidated = false;
        this.$emit('nav', type, categoryQuestionIds, false);
      }
      else if(type === 'next') {
        this.isValidated = true;

        obs.validate().then(passed => {
          if(passed === true) {
            this.isValidated = false;
          }

          this.$emit('nav', type, categoryQuestionIds, passed);
        });
      }
    },
    putSectionResponses(categoryQuestionIds, isAsync = true) {
      this.$emit('putSectionResponses', categoryQuestionIds, isAsync);
    },
  },
  watch: {
    activeSectionId: function (newId, oldId) {
      let obs = this.$refs.observer;
      obs.reset();
    }
  }
}
</script>
